// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"584":"394d10e7","593":"888410fd","726":"64f39145","801":"38982e4c","880":"93dc3564","941":"9e7a6820","988":"54aab439"}[chunkId] + ".chunk.js";
};